import { Link, useLocation } from 'react-router'
import { useCustomSEO } from '../hooks/useSEO'

export default function NotFoundPage() {
  const location = useLocation()

  useCustomSEO('Page Not Found | Optioneer', 'The page you requested could not be found.', {
    noindex: true,
    canonical: `https://optioneer.io${location.pathname}`,
  })

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center px-4">
      <div className="max-w-lg text-center">
        <p className="text-sm font-semibold text-brand-600 dark:text-amber-400 mb-3">Error 404</p>
        <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-4">Page not found</h1>
        <p className="text-slate-600 dark:text-slate-400 mb-8">
          The URL you entered does not exist or has moved.
        </p>
        <Link
          to="/"
          className="inline-flex items-center rounded-xl bg-brand-600 px-5 py-3 font-medium text-white hover:bg-brand-700 dark:bg-amber-500 dark:text-slate-900 dark:hover:bg-amber-400 transition-colors"
        >
          Go to homepage
        </Link>
      </div>
    </div>
  )
}
